import React from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { ShieldCheckIcon } from 'lucide-react';
export function RegisteredNurses() {
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-961">
      <Navbar data-id="element-962" />
      <main className="flex-1" data-id="element-963">
        <section className="w-full bg-gray-50 py-16 lg:py-24 border-b border-gray-100" data-id="element-964">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-965">
            <div className="inline-flex items-center gap-2 bg-soft-teal text-accent-teal-dark text-xs font-semibold px-3 py-1.5 rounded-full mb-4" data-id="element-966">
              <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-967" />
              Services
            </div>
            <h1 className="text-4xl sm:text-5xl font-extrabold text-text-dark tracking-tight mb-6" data-id="element-968">
              Registered Nurses (RN)
            </h1>
            <p className="text-lg text-text-muted max-w-2xl mx-auto leading-relaxed" data-id="element-969">
              Highly skilled Registered Nurses for complex care, acute settings,
              and clinical leadership.
            </p>
          </div>
        </section>
        <div className="max-w-3xl mx-auto px-4 py-16 text-text-muted leading-relaxed space-y-6" data-id="element-970">
          <p data-id="element-971">
            Our Registered Nurses (RNs) bring extensive clinical expertise and
            leadership to your facility. They are equipped to handle complex
            patient care, administer medications, manage care plans, and provide
            critical oversight.
          </p>
          <p data-id="element-972">
            Every RN on the Care Nomad platform is fully vetted, with verified
            CNO/CARNA/BCCNM registration, reference checks, and clinical
            competency assessments. We ensure you get the right nurse for your
            specific needs, whether it's for an ICU, ER, or long-term care
            setting.
          </p>
        </div>
      </main>
      <StickyFooter data-id="element-973" />
    </div>;
}